module.exports = "/_next/static/images/t2-3f426a6cc7e1b32ebcbce0947ec191fc.svg";